import { Skeleton, Stack, styled } from '@mui/material'

import { COLORS, unit } from '@hcr/ui'

export const AdditionalInfoListLoading = () => {
  return (
    <Stack>
      {Array.from({ length: 3 }).map((_, key) => (
        <Element key={key}>
          <Skeleton width={unit(50)} height={unit(6)} />
          <Skeleton width={unit(40)} height={unit(6)} />
        </Element>
      ))}
    </Stack>
  )
}

const Element = styled(Stack)`
  padding-top: ${unit(2)};
  padding-bottom: ${unit(3)};

  :not(:last-of-type) {
    border-bottom: ${unit(0.25)} dashed ${COLORS.vaalea[700]};
  }
`
